export const SET_LEASE_STATUSES = 'SET_LEASE_STATUSES';
export const RESET_LEASE_STATUSES = 'RESET_LEASE_STATUSES';
